import { render, staticRenderFns } from "./RecentActivityCardReview.vue?vue&type=template&id=38db10ee&scoped=true&"
import script from "./RecentActivityCardReview.vue?vue&type=script&lang=js&"
export * from "./RecentActivityCardReview.vue?vue&type=script&lang=js&"
import style0 from "./RecentActivityCardReview.vue?vue&type=style&index=0&id=38db10ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38db10ee",
  null
  
)

export default component.exports